<template>
  <div class="mb-3 col-sm-12 col-md-6 col-lg-6 p-0">
  
    <div class="input-group">
      <input
        type="search"
        class="form-control search-input"
        :placeholder="'Filter these ' + totalCount + ' results by keyword'"
        v-model="searchTerm"
        @input="onSearchInput"
        v-on:keyup.enter="onEnter"
      />
      <div class="input-group-append">
        <button tabindex="-1" type="submit" class="btn text-size-normal btn btn-light" @click="onEnter">
          <span class="png-icon png-icon-icons-glyph--k-search"></span>
        </button>
      </div>
    </div>

    <div
      class="search-suggestion w-100"
      v-if="suggestions.length > 0 && searchTerm && showSuggestion"
    >
      <div v-for="item in suggestions" :key="item">
        <p
          class="font-24 px-2 py-1 mb-0"
          @click="suggestionUpdate(item)"
          :id="item"
        >
          {{ item }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      timeout: null,
      showSuggestion: false,
      searchTerm: ""
    };
  },
  computed: {
    ...mapGetters({
      suggestions: "benjaminMoore/suggestions",
      totalCount: "benjaminMoore/totalCount",
      getSearchTerm: "benjaminMoore/getSearchTerm",
    })
  },
  methods: {
    ...mapActions({
      getSuggestions: "benjaminMoore/getSuggestions",
      getBenjaminMooreProducts: "benjaminMoore/getBenjaminMooreProducts"
    }),
    onSearchInput(e) {
      if (e.srcElement.value === '') {
        this.suggestionUpdate('');
      }
      else{
        if (this.timeout) clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.setShowSuggestion(true);
          this.getSuggestions(e.srcElement.value);
        }, 800);
      }
    },
    onEnter: function(e) {
      this.suggestionUpdate(this.searchTerm);
    },
    suggestionUpdate(item) {
      this.searchTerm = item;
      this.getBenjaminMooreProducts({ searchTerm: item });
      this.setShowSuggestion(false);
    },
    setShowSuggestion(value) {
      this.showSuggestion = value;
    },
    handleClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.setShowSuggestion(false);
      }
    },
    updateModel(){
      this.searchTerm = this.getSearchTerm
    }
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
    this.updateModel();
  },
  destroyed() {
    document.removeEventListener("click", this.handleClickOutside);
  }
};
</script>
